import React from 'react';
import { CheckCircle2, Sparkles, Shield, Leaf } from 'lucide-react';
import './AboutSection.css';

const AboutSection = () => {
  const benefits = [
    {
      icon: <Leaf size={32} />,
      title: 'Umweltfreundlich',
      description: 'CO₂ wird wiederverwendet, keine chemischen Rückstände'
    },
    {
      icon: <Shield size={32} />,
      title: 'Schonend',
      description: 'Keine Beschädigung empfindlicher Oberflächen'
    },
    {
      icon: <Sparkles size={32} />,
      title: 'Rückstandsfrei',
      description: 'Trockene Reinigung ohne Nacharbeit'
    },
    {
      icon: <CheckCircle2 size={32} />,
      title: 'Effizient',
      description: 'Schnelle Reinigung ohne lange Ausfallzeiten'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-content">
          <h2 className="about-title">Über Trockeneistrahlen</h2>
          <p className="about-text">
            Trockeneistrahlen ist eine innovative und umweltfreundliche Reinigungsmethode, 
            bei der <strong>gefrorenes CO₂</strong> (Trockeneis) mit hoher Geschwindigkeit auf Oberflächen 
            gestrahlt wird. Die Pellets sublimieren sofort bei Kontakt und entfernen dabei 
            Schmutz, Öl, Fett und andere Verunreinigungen – ganz <strong>ohne chemische Zusatzstoffe</strong> 
            oder <strong>Feuchtigkeit</strong>.
          </p>
          <p className="about-text">
            Diese Methode ist besonders geeignet für <strong>empfindliche Maschinen</strong>, <strong>elektrische 
            Anlagen</strong> und Produktionsumgebungen, wo herkömmliche Reinigungsverfahren zu 
            Beschädigungen oder langen Ausfallzeiten führen würden.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="team-section">
          <h2 className="team-title">Über Uns</h2>
          <p className="team-text">
            Wir sind Max und Chris. Kennengelernt haben wir uns durch unsere gemeinsame Leidenschaft für das Motorradfahren, eine Verbindung aus der schnell mehr als nur ein gemeinsames Hobby wurde. Bereits kurz nach unserem ersten Treffen stellte Max eine innovative Methode vor, mit der Motorräder besonders schonend und zugleich äußerst effizient gereinigt werden können. Die Begeisterung war sofort da und damit auch der Entschluss, diese Idee weiterzuverfolgen.
          </p>
          <p className="team-text">
            Nur wenig später beschäftigten wir uns intensiv mit ersten Geschäftskonzepten und der Frage, wie sich unsere Leidenschaft in ein professionelles Unternehmen überführen lässt. Nach Monaten sorgfältiger Planung, kreativer Entwicklung und konsequenter Umsetzung war es schließlich so weit: Am 01.09.2025 wurde unser Unternehmen gegründet.
          </p>
          <p className="team-text">
            Unser Anspruch ist eindeutig: Wir bieten eine schnelle, mobile und professionelle Lösung im Bereich Trockeneisstrahlen. Dabei stehen Qualität, Zuverlässigkeit und Präzision für uns an erster Stelle. Mit Leidenschaft für unsere Arbeit und einem hohen Qualitätsanspruch setzen wir alles daran, für unsere Kundinnen und Kunden stets das bestmögliche Ergebnis zu erzielen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;